import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { FileText, Images, LayoutTemplate, LogOut, Mail } from 'lucide-react';
import { Button } from './components/ui/button';
import { useAdminAuth } from './AdminAuth';
import { cn } from './lib/utils';

function formatAccount(value?: string) {
  if (!value) return '';
  const digits = value.replace(/\D/g, '');
  if (digits.length === 12 && digits.startsWith('91')) {
    return `+91 ${digits.slice(2)}`;
  }
  return value;
}

const links = [
  { to: '/admin', label: 'Overview', icon: LayoutTemplate, end: true },
  { to: '/admin/photos', label: 'Photos', icon: Images, end: false },
  { to: '/admin/carousel', label: 'Carousel', icon: LayoutTemplate, end: false },
  { to: '/admin/content', label: 'Content', icon: FileText, end: false },
  { to: '/admin/messages', label: 'Messages', icon: Mail, end: false },
];

const AdminLayout: React.FC = () => {
  const { session, signOut } = useAdminAuth();

  return (
    <div className="tw-flex tw-min-h-screen">
      <aside className="tw-flex tw-w-60 tw-flex-col tw-border-r tw-border-border tw-bg-card">
        <div className="tw-border-b tw-border-border tw-px-5 tw-py-5">
          <p className="tw-text-xs tw-font-medium tw-uppercase tw-tracking-wide tw-text-muted-foreground">Humanity Trust</p>
          <p className="tw-mt-1 tw-text-lg tw-font-semibold">Admin</p>
        </div>
        <nav className="tw-flex tw-flex-1 tw-flex-col tw-gap-1 tw-p-3">
          {links.map((link) => {
            const Icon = link.icon;
            return (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.end}
                className={({ isActive }) =>
                  cn(
                    'tw-flex tw-items-center tw-gap-2 tw-rounded-md tw-px-3 tw-py-2 tw-text-sm',
                    isActive ? 'tw-bg-primary tw-text-primary-foreground' : 'tw-text-foreground hover:tw-bg-muted'
                  )
                }
              >
                <Icon size={16} />
                {link.label}
              </NavLink>
            );
          })}
        </nav>
        <div className="tw-border-t tw-border-border tw-p-3">
          <p className="tw-mb-2 tw-truncate tw-px-1 tw-text-xs tw-text-muted-foreground">
            {formatAccount(session?.user.phone || session?.user.email)}
          </p>
          <Button variant="outline" className="tw-w-full" onClick={() => signOut()}>
            <LogOut size={16} />
            Sign out
          </Button>
        </div>
      </aside>
      <main className="tw-flex-1 tw-p-8">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
